export const HAS_FIBER_MAP = 'fibermap/HAS_FIBER_MAP'
export const SET_DATA = 'fibermap/SET_DATA'
export const COMPUTE_CONTENT_LINK = 'fibermap/COMPUTE_CONTENT_LINK'
export const CONTENT_HAS_LINK = 'fibermap/CONTENT_HAS_LINK'
